<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <div
          class="weui-cell weui-cell_select weui-cell_select-after"
          slot="py_kind"
        >
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.py_kind || "计划类别"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.py_kind"
              placeholder="请选择"
            >
              <option value="年计划">年计划</option>
              <option value="月计划">月计划</option>
            </select>
          </div>
        </div>
        <div
          class="weui-cell weui-cell_access"
          slot="py_year"
          @click="selectYear"
          v-if="form.main.py_kind == '年计划'"
        >
          <div class="weui-cell__hd">
            <label for class="weui-label">年份</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.py_year }}
          </div>
          <div class="weui-cell__ft"></div>
        </div>
        <div
          class="weui-cell weui-cell_access"
          slot="py_yearmonth"
          @click="selectYearMonth"
          v-else-if="form.main.py_kind == '月计划'"
        >
          <div class="weui-cell__hd">
            <label for class="weui-label">期间</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.py_yearmonth }}
          </div>
          <div class="weui-cell__ft"></div>
        </div>
        <div
          class="weui-cell weui-cell_select weui-cell_select-after"
          slot="py_type"
        >
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.py_type || "类型"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.py_type"
              placeholder="请选择"
            >
              <option value="按客户">按客户</option>
              <option value="按品牌">按品牌</option>
            </select>
          </div>
        </div>
      </custom-layout>

      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.items"
        :key="xindex"
      >
        <div class="weui-cells__title">
          <span>产品{{ xindex + 1 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <div class="weui-cells">
          <custom-layout :view-config="customViewConfig" position="detail1">
            <customer-field
              v-if="form.main.py_type == '按客户'"
              :label="customLabel.pyd_custname || '客户名称'"
              slot="pyd_custname"
              v-model="item.pyd_custname"
              @select="onItemSelectCustomer($event, item)"
            />
            <product-field
              v-if="form.main.py_type == '按客户'"
              v-model="item.pr_detail"
              @select="onItemSelectProduct($event, item)"
              :label="customLabel.pr_detail"
              slot="pr_detail"
            />
            <div
              class="weui-cell"
              v-if="form.main.py_type == '按客户'"
              slot="pyd_prodcode"
            >
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pyd_prodcode || "产品编号"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                {{ item.pyd_prodcode }}
              </div>
            </div>
            <div
              class="weui-cell"
              v-if="form.main.py_type == '按客户'"
              slot="pr_orispeccode"
            >
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pr_orispeccode || "型号"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                {{ item.pr_orispeccode }}
              </div>
            </div>
            <combo-field
              v-if="form.main.py_type == '按品牌'"
              slot="pyd_brand"
              :label="customLabel.pyd_brand || '厂家/品牌'"
              v-model="item.pyd_brand"
              url="/api/document/productbrand/getCombo"
            />
            <div
              class="weui-cell"
              slot="pyd_total"
              v-if="form.main.py_kind == '年计划'"
            >
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pyd_total || "年度计划目标"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.pyd_total"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div
              class="weui-cell"
              slot="pyd_pretotal"
              v-if="form.main.py_kind == '年计划'"
            >
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pyd_pretotal || "上年度金额"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.pyd_pretotal"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div
              class="weui-cell"
              slot="pyd_thistotal"
              v-if="form.main.py_kind == '月计划'"
            >
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pyd_thistotal || "本月计划目标"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.pyd_thistotal"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div
              class="weui-cell"
              slot="pyd_amount1"
              v-if="form.main.py_kind == '年计划'"
            >
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pyd_amount1 || "1月"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.pyd_amount1"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div
              class="weui-cell"
              slot="pyd_amount2"
              v-if="form.main.py_kind == '年计划'"
            >
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pyd_amount2 || "2月"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.pyd_amount2"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div
              class="weui-cell"
              slot="pyd_amount3"
              v-if="form.main.py_kind == '年计划'"
            >
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pyd_amount3 || "3月"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.pyd_amount3"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div
              class="weui-cell"
              slot="pyd_amount4"
              v-if="form.main.py_kind == '年计划'"
            >
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pyd_amount4 || "4月"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.pyd_amount4"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div
              class="weui-cell"
              slot="pyd_amount5"
              v-if="form.main.py_kind == '年计划'"
            >
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pyd_amount5 || "5月"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.pyd_amount5"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div
              class="weui-cell"
              slot="pyd_amount6"
              v-if="form.main.py_kind == '年计划'"
            >
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pyd_amount6 || "1月"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.pyd_amount6"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div
              class="weui-cell"
              slot="pyd_amount7"
              v-if="form.main.py_kind == '年计划'"
            >
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pyd_amount7 || "7月"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.pyd_amount7"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div
              class="weui-cell"
              slot="pyd_amount8"
              v-if="form.main.py_kind == '年计划'"
            >
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pyd_amount8 || "8月"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.pyd_amount8"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div
              class="weui-cell"
              slot="pyd_amount9"
              v-if="form.main.py_kind == '年计划'"
            >
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pyd_amount9 || "9月"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.pyd_amount9"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div
              class="weui-cell"
              slot="pyd_amount10"
              v-if="form.main.py_kind == '年计划'"
            >
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pyd_amount10 || "10月"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.pyd_amount10"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div
              class="weui-cell"
              slot="pyd_amount11"
              v-if="form.main.py_kind == '年计划'"
            >
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pyd_amount11 || "11月"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.pyd_amount11"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div
              class="weui-cell"
              slot="pyd_amount12"
              v-if="form.main.py_kind == '年计划'"
            >
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pyd_amount12 || "12月"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.pyd_amount12"
                  placeholder="请填写"
                />
              </div>
            </div>
          </custom-layout>
          <a
            href="javascript:"
            v-if="xindex == form.items.length - 1"
            class="weui-cell weui-cell_link"
            @click="addItem"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import process from "@/mixins/process.js";
import ProductField from "@/components/field/ProductField.vue";
import CustomerField from "@/components/field/CustomerField.vue";
import ComboField from "@/components/field/ComboField.vue";

export default {
  components: {
    CustomLayout,
    CustomerField,
    ProductField,
    ComboField
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/sale/planyear",
      codeField: "py_code",
      statusField: "py_statuscode",
      caller: "PlanYear",
      xtype: "sale-planyear-formpanel",
      form: {
        main: {
          py_kind: "",
          py_year: null,
          py_type: null,
          py_yearmonth:null,
        },
        items: [
          {
            pyd_custid: null,
            pyd_custname: null,
          },
        ],
      },
    };
  },
  methods: {
    selectYear() {
      var me = this,
        main = me.form.main,
        years = [];
      main.py_year = new Date().getFullYear();
      for (let i = main.py_year - 20, len = main.py_year + 20; i <= len; i++) {
        years.push({
          value: i,
          label: i + "年",
        });
      }
      me.$weui.picker(years, {
        title: "选择年份",
        onConfirm: function (r) {
          main.py_year = r[0].value;
        },
      });
    },
    selectYearMonth() {
      let me = this,
        main = me.form.main,
        year = new Date().getFullYear(),
        month = new Date().getMonth() + 1,
        years = [],
        months = [
          { value: "01", label: "1月" },
          { value: "02", label: "2月" },
          { value: "03", label: "3月" },
          { value: "04", label: "4月" },
          { value: "05", label: "5月" },
          { value: "06", label: "6月" },
          { value: "07", label: "7月" },
          { value: "08", label: "8月" },
          { value: "09", label: "9月" },
          { value: "10", label: "10月" },
          { value: "11", label: "11月" },
          { value: "12", label: "12月" },
        ];

      for (let i = year - 20, len = year; i <= len; i++) {
        years.push({
          value: i,
          label: i + "年",
        });
      }
      me.$weui.picker(years, months, {
        title: "选择年月",
        defaultValue: [year, month],
        onConfirm: function (r) {
          main.py_yearmonth = r[0].value + r[1].value;
        },
      });
    },
    /**
     * 选择明细客户
     */
    onItemSelectCustomer(selection, item) {
      item.pyd_custid = selection.id;
    },
    /**
     * 选择明细产品
     */
    onItemSelectProduct(selection, item) {
      item.pyd_prodid = selection.id;
      item.pyd_prodcode = selection.pr_code;
      item.pr_detail = selection.pr_detail;
    },
    /**
     * 保存
     */
    save() {
      var me = this,
        main = me.form.main,
        items = me.form.items;
      if (!main.py_kind) {
        me.$weui.topTips("请选择类别", 2000);
      } else if (main.py_kind == "年计划" && !main.py_year) {
        me.$weui.topTips("请选择年份", 2000);
      } else if (main.py_kind == "月计划" && !main.py_yearmonth) {
        me.$weui.topTips("请选择期间", 2000);
      } else if (!main.py_type) {
        me.$weui.topTips("请选择类型", 2000);
      } else {
        var count = 0;
        items.forEach(function (item) {
          count++;
          item.pyd_detno = count;
        });
      }
      me.p_save();
    },
    /**
     * 删除行
     */
    removeItem(index) {
      var me = this,
        items = me.form.items;
      items.splice(index, 1);
    },
    /**
     * 新增行
     */
    addItem() {
      var me = this,
        items = me.form.items;
      items.push({});
    },
  },
};
</script>